export enum BlockType {
  NUMBERED = 'NUMBERED',
  NOT_NUMBERED = 'NOT_NUMBERED',
  DYNAMIC = 'DYNAMIC',
}
